import Nav from '../../components/breadcrumb';
import PageHeader, { Title, ActionBar, ActionButton as Btn } from '../../components/pageheader';
import { Form, Table, Card, Row, Col } from 'react-bootstrap';
import { SortButton } from '../../components/btns';
import { useState, useEffect } from 'react';
import PagePagination, { usePagination } from '../../components/pagination';
import { useScreenType } from '../../components/custom-hooks';
import moment from 'moment';
import { sortFunction } from "../../components/resources";
import { deleteDocument, getDocuments, uploadDocument } from '../../resources/api/files';
import { ErrorLoading, PageLoading } from '../../components/loading';
import { FileUpload } from '../../components/files';
import { APIURL } from '../../resources/fetch';
import { ConfirmAction } from '../../components/prompt';
import { errorAlert, infoAlert, successAlert } from '../../components/toastr';


/**
 * View table items on screens larger than md
 * @param {Object} props
 * @param {{currentField: string, currentOrder: "asc" | "desc"}} props.srt
 * @param {(field: string) => void} props.handleSort
 * @param {import('../../resources/api/files').FileObject[]} props.items
 * @param {number} props.currentPage
 * @param {number} props.noPageItems
*/
const ViewDesktop = ({ srt, handleSort, items, currentPage, noPageItems, onDelete }) => {

    const El = ({ field, children, ...props }) =>
        <th
            {...props}
            style={{ whiteSpace: "nowrap" }}
        >
            {children} <SortButton field={field} {...srt} handleSort={handleSort} />
        </th>;

    return (
        <Table responsive hover style={{ minWidth: '700px' }}>
            {/* <colgroup>
                <col span="1" style={{ width: "3%" }} />
                <col span="1" style={{ width: "25%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "16%" }} />
                <col span="1" style={{ width: "16%" }} />
            </colgroup> */}
            <thead>
                <tr>
                    <th>#</th>
                    <El field="file_title">Name</El>
                    <El field="file_group">Group</El>
                    <El field="file_size">File Size</El>
                    <El field="display_name">Added By</El>
                    <El field="date_added">Date Added</El>
                    <th>Action</th>
                </tr>

            </thead>
            <tbody>
                {items.map((e, i) => (
                    <tr key={i}>
                        <td>{(currentPage - 1) * noPageItems + i + 1}</td>
                        <td>{e.file_title}
                            {/* <Link to={`/app/files/${e.id}`}>{e.title}</Link> */}
                        </td>
                        <td>{e.file_group}</td>
                        <td>{e.file_size}</td>
                        <td>{e.display_name}</td>
                        <td>{moment(e.date_added).format("DD MMM YYYY")}</td>
                        <td>
                            <a href={`${APIURL}/files/${e.file_id}/view`} target='_blank' rel="noreferrer" className='text-secondary'><i className="fas fa-eye mx-1" /></a>
                            <a href={`${APIURL}/files/${e.file_id}/download`} target='_blank' rel="noreferrer" className='text-primary'><i className="fas fa-download mx-1" /></a>
                            <ConfirmAction
                                as={"a"}
                                href="#."
                                className="text-danger"
                                btnClass='text-danger'
                                confirmationText='Are you sure you want to delete this file?'
                                handleAction={() => onDelete(e.id)}
                            >
                                <i className="fas fa-trash-alt mx-1" />
                            </ConfirmAction>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    )
}

/**
 * view items on screens smaller than md
 * @param {Object} props
 * @param {{currentField: string, currentOrder: "asc" | "desc"}} props.srt
 * @param {(field: string) => void} props.handleSort
 * @param {import('../../resources/api/files').FileObject[]} props.items
 */
const ViewMobile = ({ srt, handleSort, items, onDelete }) => {

    const El = ({ field, children }) => (
        <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
            {children} <SortButton field={field} {...srt} handleSort={handleSort} />
        </span>
    )
    return (
        <div className="my-3">
            <div className="mb-3" style={{ whiteSpace: 'nowrap', overflowX: 'auto', maxWidth: '100%' }}>
                <El field="file_title">Name</El>
                <El field="file_group">Group</El>
                <El field="file_size">File Size</El>
                <El field="display_name">Version</El>
                <El field="date_added">Date Added</El>
            </div>
            {items.map((e, i) => (
                <Card className="my-2 shadow-sm" key={i}>
                    <Card.Body className="px-3">
                        <div className="d-flex justify-content-between mb-2">
                            <span className="text-secondary font-weight-normal text-uppercase">{e.file_group}</span>
                            <span className="text-muted font-weight-normal">{moment(e.date_added).format("DD MMM YYYY")} by {e.display_name}</span>
                        </div>

                        <div className="lead mb-2">
                            {/* <Link to={`/app/files/${e.id}`} className="stretched-link">{e.title}</Link> */}
                            {e.file_title}
                        </div>
                        <div>
                            {e.file_size} MBs
                        </div>
                        <div className=" mt-2">
                            <a href={`${APIURL}/files/${e.file_id}/view`} target='_blank' rel="noreferrer" className='text-secondary'><i className="fas fa-eye mx-1" /></a>
                            <a href={`${APIURL}/files/${e.file_id}/download`} target='_blank' rel="noreferrer" className='text-primary'><i className="fas fa-download mx-1" /></a>
                            <ConfirmAction
                                as={"a"}
                                href="#."
                                confirmationText='Are you sure you want to delete this file?'
                                className="text-danger"
                                handleAction={() => onDelete(e.id)}
                            >
                                <i className="fas fa-trash-alt mx-1" />
                            </ConfirmAction>
                            {/* <Button size="sm" variant='link' className='text-danger mx-1'><i className="fas fa-trash-alt mx-1" /></Button> */}
                        </div>
                    </Card.Body>
                </Card>
            ))}
        </div>
    )
}

/**
 * module that handles view of accounts
 * match path /app/accounts
 */
const ViewFiles = () => {

    const navItems = [{ title: 'Resource Center' }];

    const [srt, setSrt] = useState({
        currentField: 'title',
        currentOrder: 'asc'
    });

    const [noPageItems, setNoPageItems] = useState(10);
    const [displayItems, setDisplayItems] = useState([]);
    const [items, setItems] = useState([]);
    const [orginalItems, setOriginalItems] = useState([]);
    const [search, setSearch] = useState({ val: '', field: 'title' });

    const screenType = useScreenType();
    const [PAGE, NOPAGES, setPage] = usePagination(items.length, noPageItems);

    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);

    /**
     * whenever the page changes, scroll back to the top of the list.
     */
    useEffect(() => {
        if (PAGE === 1) return;
        window.scrollTo({ top: 100, behavior: "smooth" });
    }, [PAGE])

    /**
     * whenever the value and field change ie. a search, 
     * filter the items and view on the page.
     */
    useEffect(() => {
        const v = search.val, f = search.field;
        if (v.length < 2 || f === "") return setItems(orginalItems);
        setItems([...orginalItems.filter(i => i[f].toLowerCase().indexOf(v.toLowerCase()) !== -1)]);
    }, [search.val, search.field, orginalItems]);


    /**
     * get the items
     */
    useEffect(() => {

        getDocuments()
            .then(({ documents }) => {
                setOriginalItems(documents);
                setItems(documents);
            })
            .catch(err => setError(err))
            .finally(() => setLoaded(true))
    }, [])


    /**
     * Update display items whenever 
     * (1) => the page changes 
     * (2) => the number of items a page changes 
     * (3) => items change in any way
     */
    useEffect(() => {

        const ditems = [],
            start = (PAGE * noPageItems) - noPageItems,
            end = (PAGE * noPageItems) > items.length ? items.length : PAGE * noPageItems;

        for (let index = start; index < end; index++) {
            ditems.push(items[index]);
        }

        setDisplayItems(ditems);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [PAGE, noPageItems, JSON.stringify(items)])

    /**
     * Is triggered when 
     * (1) => user has changed the sort field
     * (2) => user has changed sort order
     * (3) => user has changed length of items (i.e., there are new items in the page)
     */
    useEffect(() => {

        const comp = (a, b) => sortFunction(a, b, srt.currentField, srt.currentOrder);

        setItems(items => [...items].sort(comp));

    }, [srt.currentField, srt.currentOrder, items.length])

    /**
     * handle when someone clicks the sort button
     * @param {string} field 
     */
    const handleSort = field => {
        if (field === srt.currentField) {
            setSrt(d => ({ ...d, currentOrder: d.currentOrder === 'asc' ? 'desc' : 'asc' }));
        } else {
            setSrt(d => ({ currentField: field, currentOrder: 'asc' }));
        }
    }

    const handleFileDelete = id => {
        infoAlert("Deleting file...");

        deleteDocument(id)
            .then(({ message }) => {
                successAlert(message);
                setOriginalItems(_items => _items.filter(i => i.id !== id));
            })
            .catch(errorAlert)
    }

    const handleFileUpload = file => {
        infoAlert("Uploading file to resource center now ...");

        uploadDocument({ file_id: file.id })
            .then(({ document, message }) => {
                setOriginalItems(i => i.concat(document));
                successAlert(message);
            })
            .catch(errorAlert)
    }

    if (!loaded) return <PageLoading />

    if (error) return <ErrorLoading>{error}</ErrorLoading>


    return (
        <>
            <Nav items={navItems} />

            <PageHeader maxWidth="1000">
                <Title>Resource Center</Title>
                <ActionBar>
                    <FileUpload
                        as={Btn}
                        onUpload={handleFileUpload}
                        title="Upload File"
                    >
                        <i className="fas fa-plus-circle" />
                    </FileUpload>
                </ActionBar>
            </PageHeader>

            <div className="max-1000">
                <Row xs={{ cols: "auto" }} className="align-items-center justify-content-md-end mb-3 flex-nowrap g-0">
                    <Col>

                        <Form.Control placeholder="Search For" size="sm"
                            value={search.val}
                            onChange={e => setSearch({ ...search, val: e.currentTarget.value })}
                        />
                    </Col>
                    <Col>
                        <span className="mx-1">in</span>
                    </Col>
                    <Col>
                        <Form.Select as="select" size="sm"
                            value={search.field}
                            onChange={e => setSearch({ ...search, field: e.currentTarget.value })}
                        >
                            <option value="title">Name</option>
                            <option value="file_group">Group</option>
                        </Form.Select>
                    </Col>


                </Row>

                {screenType === 'desktop' ?
                    <ViewDesktop
                        srt={srt}
                        handleSort={handleSort}
                        items={displayItems}
                        noPageItems={noPageItems} currentPage={PAGE}
                        onDelete={handleFileDelete}
                    /> :
                    <ViewMobile srt={srt} handleSort={handleSort} items={displayItems} onDelete={handleFileDelete} />
                }

                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                    <Row xs={{ cols: "auto" }} className="align-items-center g-0 flex-nowrap mb-2">
                        <Col className="me-2 text-nowrap">No Items:</Col>
                        <Col>
                            <Form.Select
                                value={noPageItems}
                                onChange={e => setNoPageItems(parseInt(e.currentTarget.value))}
                                size="sm"
                                style={{ maxWidth: '100px' }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </Form.Select>
                        </Col>

                        <Col className="ms-2 text-nowrap">{items.length} of {orginalItems.length}</Col>
                    </Row>
                    <PagePagination
                        page={PAGE}
                        no_pages={NOPAGES}
                        setPage={setPage}
                    />
                </div>
            </div>
        </>
    )
}


export default ViewFiles;